const isColor = (strColor) => {
  const s = new Option().style
  s.color = strColor
  return s.color !== ""
}
export const getColor = (colorObj) => (isColor(colorObj.color) ? colorObj.color : colorObj.default)

export const getFont = (size, family) => {
  const fontFamily = family
  const fontFamilies = `ui-sans-serif, ${fontFamily}, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji`
  const fontSize = size
  return `bold ${fontSize}px ${fontFamilies}`
}

export const downloadDataAndSettings = (dataObjToWrite, filename = "terminal-commands.json") => {
  const blob = new Blob([JSON.stringify(dataObjToWrite)], { type: "text/json" })
  const link = document.createElement("a")

  link.download = filename
  link.href = window.URL.createObjectURL(blob)
  link.dataset.downloadurl = ["text/json", link.download, link.href].join(":")

  const evt = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true
  })

  link.dispatchEvent(evt)
  link.remove()
}

export const uploadDataAndSettings = async () => {
  let commands = await new Promise((resolve) => {
    const inputFileElement = document.createElement("input")
    inputFileElement.setAttribute("type", "file")
    inputFileElement.setAttribute("multiple", "true")
    inputFileElement.setAttribute("accept", ".json")

    inputFileElement.addEventListener(
      "change",
      async (event) => {
        const { files } = event.target
        if (!files) {
          return
        }

        const filePromises = [...files].map((file) => file.text())

        resolve(await Promise.all(filePromises))
      },
      false
    )
    inputFileElement.click()
  })
  return commands
}

export const testJSON = (data) => {
  try {
    const { newCommands, newSettings, newColors } = JSON.parse(data[0])
    const isCommandsValid = newCommands.every(
      (cmd) =>
        cmd.hasOwnProperty("line") &&
        cmd.hasOwnProperty("timeout") &&
        cmd.hasOwnProperty("path") &&
        cmd.hasOwnProperty("shouldType")
    )
    const checker = (arr, target) => target.every((v) => arr.includes(v))
    const isSettingsValid = checker(Object.keys(newSettings), ["width", "height", "fontFamily", "fontSize", "typeWaitMs"])
    const isColorsValid = checker(Object.keys(newColors), ["header", "leftBtn", "rightBtn", "path", "command"])

    if (newCommands.length > 0 && isCommandsValid && isSettingsValid) return { newCommands, newSettings, newColors }
  } catch (err) {
    throw new Error("Invalid JSON, please use valid JSON", err)
  }

  throw new Error("Given commands JSON is not valid")
}
